import { styled } from "../../../styled-components";
import { browserMightBeOniOS } from "../../../../lib/browser-detect";
import color from "color";

export const TagOverlayView = styled.div<{ round: boolean }>`
    ${p => p.theme.fontStyles.Tag6};

    background-color: ${p => p.theme.primaryAccentColor};
    color: ${p => (color(p.theme.primaryAccentColor).luminosity() > 0.5 ? "black" : "white")};

    padding: 2px 12px ${browserMightBeOniOS ? 4 : 3}px;

    border-radius: ${p => (p.round ? 100 : 0)}px;

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    pointer-events: none !important;
`;
